import React, { useState, useEffect } from "react";
import axios from 'axios';
import Select from "react-select";
import ToastNotification from "../../components/ToastNotification/ToastNotification";
import { MdOutlinePersonOff } from "react-icons/md";
import { HiOutlineUserGroup } from "react-icons/hi";
function Payroll() {
  const [searchTerm, setSearchTerm] = useState('');
  const [getStaff, setGetStaff] = useState([]);
  const [toast, setToast] = useState({
    show: false,
    message: '',
    bg: 'success'
  });
  const showToast = (msg, bg = 'success') => {
    setToast({
      show: true,
      message: msg,
      bg
    });
  };
  const [showPayrollForm, setShowPayrollForm] = useState(false);
  const [selectedStaff, setSelectedStaff] = useState(null);
  const [attendanceData, setAttendanceData] = useState([]);
  const [presentCount, setPresentCount] = useState(0);
  const [absentCount, setAbsentCount] = useState(0);
  const [leaveCount, setLeaveCount] = useState(0);
  const [totalOvertime, setTotalOvertime] = useState("0h 0m");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [netSalary, setNetSalary] = useState("");
  const [isManual, setIsManual] = useState(false);
  const [existingPayroll, setExistingPayroll] = useState(null);
  const [payrollMap, setPayrollMap] = useState({});
  const [selectedMonth, setSelectedMonth] = useState(new Date().toISOString().slice(0, 7) // default current month
  );

  // const handleGeneratePayroll = (staff) => {
  //   setSelectedStaff(staff);
  //   setShowPayrollForm(true);
  //   fetchAttendenceByStaff(staff.id); 
  // };

  const handleGeneratePayroll = async staff => {
    try {
      // const res = await axios.get(
      // Configuration details withheld; supply approved runtime settings. 
      // );
      const res = await axios.get(`https://api.sweepydo.in/check-payroll?staff_id=${staff.id}&month=${selectedMonth}`);
      if (res.data) {
        // ✅ payroll already exists
        setExistingPayroll(res.data);
        setSelectedStaff(staff);
        setShowPayrollForm(true);

        // 👉 preload data
        setPresentCount(res.data.present);
        setAbsentCount(res.data.absent);
        setLeaveCount(res.data.leave_count);
        setTotalOvertime(res.data.total_over_time);
        setEarnings(JSON.parse(res.data.earnings || "[]"));
        setDeductions(JSON.parse(res.data.deductions || "[]"));
        setNetSalary(res.data.net_salary);
      } else {
        setExistingPayroll(null);
        setSelectedStaff(staff);
        setShowPayrollForm(true);
        fetchAttendenceByStaff(staff.id);
      }
    } catch (err) {
      console.log(err);
    }
  };
  const [earnings, setEarnings] = useState([{
    description: "",
    amount: ""
  }]);
  const [deductions, setDeductions] = useState([{
    description: "",
    amount: ""
  }]);
  const handleAddEarning = () => {
    setEarnings([...earnings, {
      description: "",
      amount: ""
    }]);
  };
  const handleRemoveEarning = index => {
    setEarnings(earnings.filter((_, i) => i !== index));
  };
  const handleEarningChange = (index, field, value) => {
    const updated = [...earnings];
    updated[index][field] = value;
    setEarnings(updated);
  };

  // 🔽 SAME FOR DEDUCTIONS

  const handleAddDeduction = () => {
    setDeductions([...deductions, {
      description: "",
      amount: ""
    }]);
  };
  const handleRemoveDeduction = index => {
    setDeductions(deductions.filter((_, i) => i !== index));
  };
  const handleDeductionChange = (index, field, value) => {
    const updated = [...deductions];
    updated[index][field] = value;
    setDeductions(updated);
  };
  const calculateSalary = () => {
    const base = (selectedStaff?.basic_salary || 0) / 30 * presentCount;
    const totalEarnings = earnings.reduce((sum, item) => sum + Number(item.amount || 0), 0);
    const totalDeductions = deductions.reduce((sum, item) => sum + Number(item.amount || 0), 0);
    return Math.round(base + totalEarnings - totalDeductions);
  };
  useEffect(() => {
    if (selectedStaff) {
      fetchAttendenceByStaff(selectedStaff.id);
    }
  }, [selectedStaff]);
  useEffect(() => {
    if (!isManual) {
      setNetSalary(calculateSalary());
    }
  }, [presentCount, earnings, deductions, selectedStaff]);
  const fetchSetaff = async () => {
    try {
      const res = await axios.get("https://api.sweepydo.in/fetch-staff");
      setGetStaff(res.data);
    } catch (error) {
      console.log(error);
    }
  };
  const fetchAttendenceByStaff = async () => {
    try {
      let url = `https://api.sweepydo.in/fetch-attendence-staff-wise?staff_id=${selectedStaff?.id}`;
      if (selectedMonth) {
        url += `&month=${selectedMonth}`;
      }
      if (fromDate && toDate) {
        url += `&from=${fromDate}&to=${toDate}`;
      }
      const res = await axios.get(url);
      const data = res.data;

      // console.log(data,'data')

      setAttendanceData(data);
      let present = 0;
      let absent = 0;
      let leave = 0;
      let totalOvertimeMinutes = 0;
      data.forEach(item => {
        if (item.status === "Present") present++;else if (item.status === "Absent") absent++;else if (item.status === "Leave") leave++;

        // ✅ OVERTIME (convert HH:MM:SS to minutes)
        if (item.over_time) {
          const [h, m, s] = item.over_time.split(":").map(Number);
          totalOvertimeMinutes += h * 60 + m + (s ? s / 60 : 0);
        }
      });
      const hours = Math.floor(totalOvertimeMinutes / 60);
      const minutes = Math.floor(totalOvertimeMinutes % 60);
      setPresentCount(present);
      setAbsentCount(absent);
      setLeaveCount(leave);
      setTotalOvertime(`${hours}h ${minutes}m`);
    } catch (error) {
      console.log(error);
    }
  };

  // const fetchPayrollStatus = async () => {
  //   try {
  // Configuration details withheld; supply approved runtime settings. 

  //     const map = {};
  //     res.data.forEach(item => {
  //       map[item.staff_id] = true;
  //     });

  //     setPayrollMap(map);

  //   } catch (err) {
  //     console.log(err);
  //   }
  // };

  const fetchPayrollStatus = async () => {
    try {
      const res = await axios.get(`https://api.sweepydo.in/payroll-status?month=${selectedMonth}`);
      const map = {};
      res.data.forEach(item => {
        map[item.staff_id] = true;
      });
      setPayrollMap(map);
    } catch (err) {
      console.log(err);
    }
  };
  useEffect(() => {
    if (selectedStaff) {
      fetchAttendenceByStaff();
      setExistingPayroll(null);
    }
  }, [selectedMonth]);
  useEffect(() => {
    fetchPayrollStatus();
    fetchSetaff();
  }, []);
  useEffect(() => {
    fetchPayrollStatus();
  }, [selectedMonth]);
  const handleSubmitPayroll = async () => {
    try {
      const payload = {
        staff_id: selectedStaff.id,
        present: presentCount,
        absent: absentCount,
        leave: leaveCount,
        total_over_time: totalOvertime,
        basic_salary: selectedStaff.basic_salary || 0,
        net_salary: netSalary,
        earnings: earnings,
        deductions: deductions,
        from_date: fromDate || null,
        to_date: toDate || null
      };
      await axios.post("https://api.sweepydo.in/save-payroll", payload);
      showToast("Payroll saved successfully!", "success");
      setShowPayrollForm(false);
      fetchPayrollStatus();
    } catch (error) {
      console.log(error);
      showToast("Failed to save payroll!", "danger");
    }
  };

  // const resetPayrollForm = () => {
  //   setShowPayrollForm(false);
  //   setSelectedStaff(null);

  //   setAttendanceData([]);
  //   setPresentCount(0);
  //   setAbsentCount(0);
  //   setLeaveCount(0);
  //   setTotalOvertime("0h 0m");

  //   setFromDate("");
  //   setToDate("");

  //   setEarnings([{ description: "", amount: "" }]);
  //   setDeductions([{ description: "", amount: "" }]);

  //   setNetSalary("");
  //   setIsManual(false);
  // };

  const resetPayrollForm = () => {
    setShowPayrollForm(false);
    setTimeout(() => {
      setSelectedStaff(null);
      setAttendanceData([]);
      setPresentCount(0);
      setAbsentCount(0);
      setLeaveCount(0);
      setTotalOvertime("0h 0m");
      setFromDate("");
      setToDate("");
      setEarnings([{
        description: "",
        amount: ""
      }]);
      setDeductions([{
        description: "",
        amount: ""
      }]);
      setNetSalary("");
      setIsManual(false);
    }, 0);
  };
  const filteredData = Array.isArray(getStaff) ? getStaff.filter(itm => Object.values(itm).some(val => String(val).toLowerCase().includes(searchTerm.toLowerCase()))) : [];
  return <div className="container-fluid mt-1 p-4">

         <ToastNotification show={toast.show} message={toast.message} bg={toast.bg} onClose={() => setToast({
      ...toast,
      show: false
    })} />
            <h2 className="text-center mb-4 text-white">Payroll </h2>

{showPayrollForm && selectedStaff && <div className="shadow rounded my-4 p-4" style={{
      backgroundColor: "var(--black)",
      color: "#fff"
    }}>

    <h4 style={{
        color: "#ff4d4f"
      }}>Payroll Details</h4>

    {/* TOP DETAILS */}
    <div className="row mt-4">

    

      <div className="col-md-12">
        <p>Employee Name: {selectedStaff.staff_name || selectedStaff.name}</p>
      </div>

     <div className="col-md-12">
        <p>Employee Contact: {selectedStaff.mobile}</p>
      </div>

      <div className="col-md-12">
        <p>Salary: ₹{selectedStaff.basic_salary || 0}</p>
      </div>

    </div>

    <hr />

    {/* ATTENDANCE TABLE STYLE */}
    <div className="row text-center mt-3">

      <div className="col">Present</div>
      <div className="col">Absent</div>
      <div className="col">Leave</div>
      <div className="col">Total Extra Hour</div>
   

    </div>

    <hr />

    <div className="row text-center">
  <div className="col">{presentCount}</div>
  <div className="col">{absentCount}</div>
  <div className="col">{leaveCount}</div>
  <div className="col">{totalOvertime}</div>
     
     
     

    </div>

    <hr />


    <h5 className="mt-4">Additional Earnings</h5>

{earnings.map((item, index) => <div className="row mb-2 align-items-center" key={index}>

    <div className="col-md-2">
      <input type="text" placeholder="Description" className="form-control rounded-pill" value={item.description} onChange={e => handleEarningChange(index, "description", e.target.value)} />
    </div>

    <div className="col-md-2">
      <input type="number" placeholder="Amount" className="form-control rounded-pill" value={item.amount} onChange={e => handleEarningChange(index, "amount", e.target.value)} />
    </div>

    <div className="col-md-2">
      <button className="btn btn-outline-warning rounded-pill" onClick={() => handleRemoveEarning(index)}>
        Remove
      </button>
    </div>

  </div>)}


{!existingPayroll && <button className="btn btn-warning rounded-pill px-4 mt-2" onClick={handleAddEarning}>
  + Add More
</button>}

<h5 className="mt-4">Additional Deductions</h5>

{deductions.map((item, index) => <div className="row mb-2 align-items-center" key={index}>

    <div className="col-md-2">
      <input type="text" placeholder="Description" className="form-control rounded-pill" value={item.description} onChange={e => handleDeductionChange(index, "description", e.target.value)} />
    </div>

    <div className="col-md-2">
      <input type="number" placeholder="Amount" className="form-control rounded-pill" value={item.amount} onChange={e => handleDeductionChange(index, "amount", e.target.value)} />
    </div>

    <div className="col-md-2">
      <button className="btn btn-outline-warning rounded-pill" onClick={() => handleRemoveDeduction(index)}>
        Remove
      </button>
    </div>

  </div>)}


{!existingPayroll && <button className="btn btn-outline-warning rounded-pill px-4 mt-2" onClick={handleAddDeduction}>
  + Add More
</button>}

  

    <div className="row  g-3 mt-4">
        <div className="col-md-4"> 
                  <label className="form-label">Net Salary</label>
                  

  <input type="number" className="form-control" value={netSalary} onChange={e => {
            setNetSalary(e.target.value);
            setIsManual(true);
          }} disabled={!!existingPayroll} />
        </div>
 
</div>

    {/* BUTTONS */}
    <div className="mt-4 d-flex gap-2">
{!existingPayroll && <button className="btn btn-warning" onClick={handleSubmitPayroll}>
        Submit Payroll
      </button>}
      <button className="btn btn-outline-light" onClick={resetPayrollForm}>
        Go Back
      </button>

    </div>

  </div>}




 {!showPayrollForm && <div className="shadow rounded my-4 p-4" style={{
      backgroundColor: "var(--black)"
    }}>

  {/* <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap">
   
    <div style={{ width: "280px" }}>
      <input
        type="text"
        className="form-control"
        placeholder="Search ..."
           value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        style={{
          backgroundColor: "var(--black2)",
          color: "#fff",
          border: "1px solid #2d3748",
          borderRadius: "10px",
          padding: "10px 14px"
        }}
      />
    </div>
    </div> */}


 <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap">

  {/* SEARCH */}
  <div style={{
          width: "280px"
        }}>
    <input type="text" className="form-control" placeholder="Search ..." value={searchTerm} onChange={e => setSearchTerm(e.target.value)} style={{
            backgroundColor: "var(--black2)",
            color: "#fff",
            border: "1px solid #2d3748",
            borderRadius: "10px",
            padding: "10px 14px"
          }} />
  </div>

  {/* MONTH PICKER */}
  <div style={{
          width: "200px"
        }}>
    <input type="month" className="form-control" value={selectedMonth} onChange={e => setSelectedMonth(e.target.value)} style={{
            backgroundColor: "var(--black2)",
            color: "#fff",
            border: "1px solid #2d3748",
            borderRadius: "10px"
          }} />
  </div>

</div>

  <div className="table-responsive shadow p-3 mb-5  rounded my-4">
    <table className='table table-dark table-bordered table-hover text-center align-middle' style={{
          backgroundColor: "var(--black)",
          color: "#fff"
        }}>
      <thead>
        <tr>
          <th style={{
                backgroundColor: "var(--black2)",
                color: "#fff"
              }}>SN</th>
          <th style={{
                backgroundColor: "var(--black2)",
                color: "#fff"
              }}>Name</th>
            <th style={{
                backgroundColor: "var(--black2)",
                color: "#fff"
              }}>Contact </th>
                    <th style={{
                backgroundColor: "var(--black2)",
                color: "#fff"
              }}>Email </th>
            
          <th style={{
                backgroundColor: "var(--black2)",
                color: "#fff"
              }}>Action</th>
        </tr>
      </thead>

    <tbody>
 
               {filteredData.map((s, i) => <tr key={s.id}>
                   <td>{filteredData.length - i}</td>
                   <td>{s.name} </td>
                   <td>{s.mobile} </td>
                   <td>{s.email} </td>
             
              <td>
        {/* <button
         className="btn btn-primary"
         onClick={() => handleGeneratePayroll(s)}
         >
         Generate Payroll
         </button> */}

<button className={`btn ${payrollMap[s.id] ? "btn-success" : "btn-primary"}`} onClick={() => handleGeneratePayroll(s)}>
  {payrollMap[s.id] ? "View Payroll" : "Generate Payroll"}
</button>


                 </td>
                 </tr>)}
             </tbody>



    </table>
  </div>

</div>}
     </div>;
}
export default Payroll;
